import React from 'react';
import { Button } from '@blink/components';
import { ReactComponent as Coinbase } from '@blink/assets/src/icons/coinbase.svg';
import { COINBASE_DOWNLOAD_URL } from '@blink/components/src/constants/global';

import { useModalStyles } from './CoinbaseNotInstalledModal.style';
import { useHideModal } from '../ModalWrapperHooks';

export const CoinbaseNotInstalledModal = () => {
    const classes = useModalStyles();

    const { handleCloseModal } = useHideModal();

    const openCoinbaseInstall = () => {
        window.open(COINBASE_DOWNLOAD_URL, '_blank', 'noreferrer');
        handleCloseModal();
    };

    return (
        <>
            <div className={classes.wrapper}>
                <div className={classes.icon}>
                    <Coinbase />
                </div>
                <div className={classes.title}>Coinbase is not installed</div>
                <div className={classes.description}>
                    The Coinbase extension is not installed <br /> in your browser
                </div>
                <div className={classes.btn}>
                    <Button name='Install' onClick={openCoinbaseInstall} />
                </div>
            </div>
        </>
    );
};
